<template>
  <div class="loader" ref="loader"></div>
</template>

<script>
import lottie from 'lottie-web'
import loaderJson from '@js-app/lottie/loader.json'

export default {
  name: 'Loader',
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.loader,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loaderJson,
    })
  },
}
</script>

<style lang="scss" scoped>
.loader {
  width: 300px;
  height: 300px;
}
</style>
